import type { BugReportPayload } from "../../lib/bug-report.js";

export async function submitBugReport(payload: BugReportPayload): Promise<{ issueUrl: string; issueNumber: number }> {
  const res = await fetch("/api/bug-report", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = (await res.json()) as { success: boolean; data?: { issueUrl: string; issueNumber: number }; error?: { message: string } };
  if (!res.ok || !json.success || !json.data) throw new Error(json.error?.message ?? "submit failed");
  return json.data;
}
